import { OrgSiteListEntry } from "../models/organisation";
import axiosConfig from "./axiosConfig";

export interface RelatedLandlordSitesListResponse {
  sites: OrgSiteListEntry[];
}

const getRelatedLandlordSitesList = async (
  authToken: string,
  orgId: string,
  siteId: string,
  userOrgId?: string
): Promise<RelatedLandlordSitesListResponse> => {
  const { data } = await axiosConfig.get(
    `/organisation/${orgId}/site/${siteId}/related_landlord_sites${
      userOrgId ? `?userOrgId=${userOrgId}` : ""
    }`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default getRelatedLandlordSitesList;
